import breakPoints from 'helpers/Styles';

const SoldOutLabel = () => (
  <>
    <div className="sold-out-container">Sold out</div>
    <style jsx>
      {`
        .sold-out-container {
          top: 0;
          right: 43%;
          font-family: 'Roboto-Medium';
          text-transform: uppercase;
          font-size: 10px;
          line-height: 16px;
          padding: 1px 4px;
          background-color: #646464;
          border-radius: 2px;
          color: #e4e4e4;
          transform: translateY(-50%);
        }
        @media (max-width: ${breakPoints.medium}) {
          .sold-out-container {
            top: 32px;
          }
        }
      `}
    </style>
  </>
);

export default SoldOutLabel;
